<template>
  <div class="spcore-menu px-4" v-resize="calculateMenuDimensions">
    <v-icon class="icon-left" @click="scroll(-menuWidth)" v-show="showLeftScroll">mdi-chevron-left</v-icon>
    <!-- <Drag @draging="dragging" @drag-stop="draggingFinished"> -->
    <div class="menu" @click="scrollIntoView($event.target)" ref="menu">
      <router-link :to="{ name: 'spcoreBrandSummary' }">Brand summary</router-link>
      <router-link :to="{ name: 'spcoreFrmSummary' }">Frm summary</router-link>
      <router-link :to="{ name: 'spcorePatientSummary' }">Patient Summary</router-link>
      <router-link :to="{ name: 'spcorePatientList' }">Patient list</router-link>
      <router-link :to="{ name: 'spcoreProviderList' }">Provider list</router-link>
      <router-link :to="{ name: 'spcoreProductMovement' }">Product Movement</router-link>
      <router-link :to="{ name: 'spcorePharmacyNetwork' }">Pharmacy Network</router-link>
      <router-link :to="{ name: 'spcoreDataEnablement' }">Data enablement</router-link>
    </div>
    <!-- </Drag> -->
    <v-icon class="icon-right" v-show="showRightScroll" @click="scroll(menuWidth)">mdi-chevron-right</v-icon>
  </div>
</template>

<script>
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import Drag from '../../common/drag/Drag.vue';
export default {
  noExport: true,
  components: { Drag, mdiChevronLeft, mdiChevronRight, }, //eslint-disable-line
  data() {
    return {
      showLeft: false,
      showRight: false,
      menuWidth: 0,
      menuScrollWidth: 0,
      preventScrollIntoView: false,
    }
  },
  computed: {
    scrollPosition: {
      get() {
        return this.$store.state.spcoreMenuScrollPosition;
      },
      set(value) {
        this.$store.state.spcoreMenuScrollPosition = value;
      },
    },
    showLeftScroll() {
      return this.scrollPosition - 1 > 0;
    },
    showRightScroll() {
      return this.scrollPosition + this.menuWidth + 1 < this.menuScrollWidth;
    },
  },
  methods: {
    calculateMenuDimensions() {
      var menu = this.$refs.menu;
      if (menu) {
        this.menuWidth = menu.clientWidth;
        this.menuScrollWidth = menu.scrollWidth;
        if (this._isMounted) {
          this.scrollPosition = menu.scrollLeft;
        }
      }
    },
    scroll(dx) {
      this.scrollPosition += dx;
      this.scrollPosition = Math.min(Math.max(this.scrollPosition, 0), this.menuScrollWidth - this.menuWidth);
      this.$nextTick(() => this.$refs.menu.scrollTo({ left: this.scrollPosition, behavior: 'smooth' }));
    },
    scrollIntoView(target) {
      if (!this.preventScrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(this.calculateMenuDimensions, 350);
      }
      this.preventScrollIntoView = false;
    },
    dragging(event) {
      this.scrollPosition -= event.dx;
      this.$nextTick(() => this.$refs.menu.scrollTo(this.scrollPosition, 0));

      if (Math.abs(event.x) > 10)
        this.preventScrollIntoView = true;
    },
    draggingFinished(event) {
      this.$refs.menu.scrollBy(-event.dx, 0);
    },
  },
  watch: {
    '$store.state.showSPCoreFilter'() {
      this.calculateMenuDimensions();
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSPCoreMenu'] = this;
    this.$refs.menu.scrollBy(this.scrollPosition, 0);

    this.$nextTick(() => {
      var selected = document.querySelector('.router-link-active');
      if (selected)
        this.scrollIntoView(selected);
    });
  },
}
</script>

<style lang="scss" scoped>
.spcore-menu {
  position: relative;
  background: white;

  .menu {
    display: flex;
    overflow: hidden;
    a {
      display: inline-block;
      color: #002f6c;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.3px;
      line-height: 21px;
      text-align: center;
      text-transform: uppercase;
      white-space: nowrap;
      padding: 10px 12px;

      &.router-link-active {
        border-radius: 7px;
        background-color: #cce3e7;
      }
    }
  }

  .v-icon {
    // background: rgba(255, 255, 255, 0.7);
    // backdrop-filter: blur(5px);
    position: absolute;
    top: 0;
    bottom: 0;
    overflow: hidden;
    cursor: pointer;
    &.icon-left {
      left: 0;
    }
    &.icon-right {
      right: 0;
    }
  }
}
</style>